import useFormContext, { FormContext } from 'common/useFormContext';
import React, { forwardRef, useImperativeHandle } from 'react';
import { Form } from 'react-bootstrap';

export interface FormValidationProps {
    children: any;
}

export interface FormValidationRefProps {
    validate(): boolean;
}

const FormValidation = forwardRef<FormValidationRefProps, FormValidationProps>((props, ref) => {

    const formRef = React.createRef<HTMLFormElement>();
    const formContext = useFormContext(formRef);

    function validateForm(): boolean {
        return formContext.validate();
    }

    useImperativeHandle(ref, () => {
        return { validate: validateForm }
    });

    return <FormContext.Provider value={formContext}>
        <Form ref={formRef} validated={formContext.isValidated}>
            {props.children}
        </Form>
    </FormContext.Provider>;
});

export default FormValidation;